export const YEARLY_TRANSACTION_VOLUME_OPTIONS = [
  '0-10000',
  '10000-50000',
  '50000-100000',
  '100000-500000',
  '500000-',
];
